/**
 * @class {RoadgamesEvent.Special}
 * @extends {RoadgamesEvent.Finished}
 * @param {DR.events.struct.Event} event
 * @param {DR.events.struct.Stats} stats
 */
RoadgamesEvent.Special = Class(
	/**
	 * @lends {RoadgamesEvent.Special#}
	 */
	{
		state: 'finished',

		_draw() {
			this._drawWelcome();
			if (this.isRace) {
				this._drawTopSponsors();
			}
			this._drawAboutGame();
			this._drawTop();
			this._drawVideo();
			this._drawGallery();
			this._drawSocials();
		},

		_drawTop() {
			this._topNode = mkE({
				tag: 'div',
				className: 'container single-event-top',
				els: [
					{
						tag: 'a',
						className: 'anchor',
						id: 'results'
					},
					{
						tag: 'div',
						className: 'single-event-block-new',
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.finished.top.title')
							}
						]
					},
					new T.Top(null, {
						eventId: this.event.id,
						seoTitle: this.event.seoTitle
					}, {
						key: 'event.top.special',
						className: 'special',
						hasGames: true,
						hasTasks: false,
						count: 1000
					})
				]
			}).append(this.node);
		},

		_drawAboutGame() {
			var descr = mkE({
				tag: 'p',
				className: 'text',
				innerHTML: this.event.description
			});

			nl2br(descr);
			mkE({
				tag: 'div',
				className: 'container single-event-finish-about',
				els: [
					{
						tag: 'div',
						className: 'single-event-block-new',
						els: [
							{
								tag: 'h2',
								className: 'title',
								text: D.Lang.get('event.finished.about.title')
							},
							descr
						]
					}
				]
			}).append(this.node);
		},

		_onResize() {

		}

	},
	RoadgamesEvent.Finished
);
